import script from "./QuestionList.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionList.vue?vue&type=script&setup=true&lang=js"

import "./QuestionList.vue?vue&type=style&index=0&id=b147a7f8&scoped=true&lang=css"
script.__scopeId = "data-v-b147a7f8"

export default script